import ExporterPopup from "../../components/customUiForCs/ExporterPopup";

export default function exportFunction({
  title,
  path,
  selectedFields,
  autoDownloadExcel,
}) {
  return () => {
    window.setForm({
      title: title,
      component: (
        <ExporterPopup
          title={title}
          path={path}
          selectedFields={selectedFields}
          autoDownloadExcel={autoDownloadExcel}
        />
      ),
    });
  };
}
